(function () {
  'use strict';

  var script = document.querySelector('script[data-vmax-search-autocomplete]');
  if (!script) return;

  if (typeof window.fetch !== 'function' || typeof window.URL !== 'function') return;

  var predictiveSearchUrl = script.getAttribute('data-predictive-search-url');
  var resultsUrl = script.getAttribute('data-results-url');
  var productType = script.getAttribute('data-product-type');
  var minimumCharacters = 3;
  var maximumResults = 10;
  var instanceCount = 0;

  function createResultsUrl(term) {
    var url = new URL(resultsUrl, window.location.origin);
    url.searchParams.set('q', term);
    return url.pathname + url.search;
  }

  function createPredictiveTerm(term) {
    if (!productType) return term;

    var escapedProductType = productType
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
    return 'product_type:"' + escapedProductType + '" ' + term;
  }

  function initializeAutocomplete(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('form[role="search"]'), function (form) {
      if (form.hasAttribute('data-vmax-search-autocomplete-ready')) return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      instanceCount += 1;
      var listId = 'VmaxSearchSuggestions-' + instanceCount;
      var resultsList = document.createElement('ul');
      var debounceTimer = null;
      var requestController = null;
      var requestNumber = 0;
      var activeIndex = -1;

      resultsList.className = 'search-results vmax-search-autocomplete__results';
      resultsList.id = listId;
      resultsList.hidden = true;
      resultsList.setAttribute('role', 'listbox');
      resultsList.setAttribute('aria-label', script.getAttribute('data-suggestions-label'));

      form.setAttribute('data-vmax-search-autocomplete-ready', 'true');
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', listId);
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('role', 'combobox');
      form.appendChild(resultsList);

      function optionElements() {
        return resultsList.querySelectorAll('[role="option"]');
      }

      function setActiveIndex(nextIndex) {
        var options = optionElements();
        Array.prototype.forEach.call(options, function (option) {
          option.classList.remove('is-active');
          option.setAttribute('aria-selected', 'false');
        });

        if (!options.length) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
          return;
        }

        activeIndex = (nextIndex + options.length) % options.length;
        var activeOption = options[activeIndex];
        activeOption.classList.add('is-active');
        activeOption.setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView({ block: 'nearest' });
      }

      function closeResults(clearContent) {
        resultsList.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
        if (clearContent) resultsList.textContent = '';
      }

      function openResults() {
        if (!resultsList.children.length) return;
        resultsList.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function renderStatus(message) {
        resultsList.textContent = '';
        var item = document.createElement('li');
        var status = document.createElement('span');

        resultsList.setAttribute('role', 'listbox');
        item.setAttribute('role', 'none');
        item.className = 'vmax-search-autocomplete__status';
        status.setAttribute('role', 'status');
        status.textContent = message;
        item.appendChild(status);
        resultsList.appendChild(item);
        setActiveIndex(-1);
        openResults();
      }

      function renderProducts(products, term, hasMoreResults) {
        resultsList.textContent = '';
        resultsList.setAttribute('role', 'listbox');

        if (!products.length) {
          renderStatus(script.getAttribute('data-empty-label'));
          return;
        }

        products.forEach(function (product, index) {
          var item = document.createElement('li');
          var link = document.createElement('a');
          var title = document.createElement('span');

          item.setAttribute('role', 'none');
          link.id = listId + '-Option-' + index;
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          link.setAttribute('tabindex', '-1');
          link.href = product.url;
          title.className = 'title';
          title.textContent = product.title;
          link.appendChild(title);
          item.appendChild(link);
          link.addEventListener('pointerenter', function () {
            setActiveIndex(index);
          });
          resultsList.appendChild(item);
        });

        if (hasMoreResults) {
          var allItem = document.createElement('li');
          var allLink = document.createElement('a');
          var allTitle = document.createElement('span');
          var allIndex = products.length;

          allItem.setAttribute('role', 'none');
          allLink.id = listId + '-Option-' + allIndex;
          allLink.setAttribute('role', 'option');
          allLink.setAttribute('aria-selected', 'false');
          allLink.setAttribute('tabindex', '-1');
          allLink.href = createResultsUrl(term);
          allTitle.className = 'title';
          allTitle.textContent = script.getAttribute('data-all-label');
          allLink.appendChild(allTitle);
          allItem.appendChild(allLink);
          allLink.addEventListener('pointerenter', function () {
            setActiveIndex(allIndex);
          });
          resultsList.appendChild(allItem);
        }

        setActiveIndex(-1);
        openResults();
      }

      function requestProducts(term) {
        requestNumber += 1;
        var thisRequest = requestNumber;

        if (requestController) requestController.abort();
        requestController = typeof AbortController === 'function' ? new AbortController() : null;

        var url = new URL(predictiveSearchUrl, window.location.origin);
        url.searchParams.set('q', createPredictiveTerm(term));
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', String(maximumResults));
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('resources[options][fields]', 'title,variants.title,product_type');

        var requestOptions = {
          headers: { Accept: 'application/json' }
        };
        if (requestController) requestOptions.signal = requestController.signal;

        fetch(url.toString(), requestOptions)
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search request failed');
            return response.json();
          })
          .then(function (data) {
            if (thisRequest !== requestNumber || input.value.trim() !== term) return;

            var rawProducts = data && data.resources && data.resources.results
              ? data.resources.results.products || []
              : [];
            var products = rawProducts.filter(function (product) {
              return !productType || product.type === productType;
            }).slice(0, maximumResults);

            renderProducts(products, term, rawProducts.length >= maximumResults);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            if (thisRequest !== requestNumber) return;
            closeResults(true);
          });
      }

      function queueSearch() {
        window.clearTimeout(debounceTimer);
        var term = input.value.trim();

        requestNumber += 1;
        if (requestController) requestController.abort();
        requestController = null;
        closeResults(true);

        if (term.length < minimumCharacters) {
          return;
        }

        debounceTimer = window.setTimeout(function () {
          requestProducts(term);
        }, 180);
      }

      input.addEventListener('input', queueSearch);
      input.addEventListener('focus', function () {
        if (input.value.trim().length >= minimumCharacters) openResults();
      });
      input.addEventListener('keydown', function (event) {
        var options = optionElements();

        if (event.key === 'ArrowDown' && options.length) {
          event.preventDefault();
          openResults();
          setActiveIndex(activeIndex + 1);
        } else if (event.key === 'ArrowUp' && options.length) {
          event.preventDefault();
          openResults();
          setActiveIndex(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex > -1 && options[activeIndex]) {
          event.preventDefault();
          var activeLink = options[activeIndex];
          if (activeLink) window.location.assign(activeLink.href);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeResults(false);
        }
      });

      form.addEventListener('submit', function () {
        if (requestController) requestController.abort();
      });

      input.addEventListener('blur', function () {
        window.setTimeout(function () {
          if (!resultsList.contains(document.activeElement)) closeResults(false);
        }, 0);
      });

      document.addEventListener('pointerdown', function (event) {
        if (!form.contains(event.target)) closeResults(false);
      });
    });
  }

  initializeAutocomplete(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAutocomplete(event.target);
  });
})();
